import { FormControl, Validators } from '@angular/forms';
import { StockForm } from 'src/app/shared/forms/stock.form';

export class AddMedicineStockForm extends StockForm {
  get expires(): FormControl<Date | null> {
    return this.get('expires') as FormControl<Date | null>;
  }

  constructor(id: string, currentStock: number) {
    super(id, currentStock);
    this.addControl('expires', new FormControl<Date | null>(null));
    this.amount.setValidators([Validators.required, Validators.min(Number.EPSILON)]);
    this.amount.updateValueAndValidity({ emitEvent: false });
    this.amount.setValue(1);
  }
}
